import { saveItem,getItem,deleteItem } from '../hooks/itemstore';

import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Benefit from './Benefit';
import { useState } from 'react';

function EditItem(props) {
    let shortname = props.itemshortname;
    let description = "";
    let benefits = [];
    let namechangeDisabled = false;
    let deleteDisabled = true;

    if (shortname) {
        console.log("loading item " + shortname);
        let item = getItem(shortname);
        description = item.description;
        benefits = item.benefits;
        namechangeDisabled = true;
        deleteDisabled = false;
    }
    const benefitsCount=benefits.length;

    let currentBenefitsRender=[];
    benefits.forEach((benefit, index) => {
        currentBenefitsRender.push(
            <Benefit benefitNum={index} benefitName={benefit.benefit} benefitCategories={benefit.categories} expirationDate={benefit.expirationDate} />
        );
    });

    function backToBrowse() {
        // go back to browse
        props.setSelectedItem("");
        props.setActiveTab("browse");
    }

    function handleSave(event) {
        let saveBenefits = [];
        // loop from 0 to benefitsCount
        for (let i = 0; i <= benefitsCount; i++) {
            // get value of document id "benefit"+i
            const thisBenefit = document.getElementById("benefit"+i).value;
            const thisCategories = document.getElementById("categories"+i).value;
            const thisExpirationDate = document.getElementById("expirationDate"+i).value;
            if (thisBenefit.trim().length > 0) {
                // append object to array
                saveBenefits.push({
                    benefit: thisBenefit,
                    categories: thisCategories,
                    expirationDate: thisExpirationDate
                });
            }
        }

        let item = { 
            shortname: document.getElementById("shortname").value, 
            description: document.getElementById("description").value,
            benefits: saveBenefits
        };
        console.log("saving item " + item.shortname);
        console.log(item);
        saveItem(item);
        backToBrowse();
    }

    function handleCancel(event) {
        console.log("cancelling edit");
        backToBrowse();
    }

    function handleDelete(event) {
        console.log("deleting "+shortname);
        let item = { 
            shortname: document.getElementById("shortname").value
        }
        deleteItem(item);
        backToBrowse();
    }

    console.log("painted Edititem");

    return (
        <Form>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Card Short Name
                </Form.Label>
                <Col sm="10">
                    {namechangeDisabled &&
                        <Form.Control id="shortname" defaultValue={shortname} disabled />
                     ||
                        <Form.Control id="shortname" defaultValue={shortname} />
                    }
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Card Description
                </Form.Label>
                <Col sm="10">
                    <Form.Control id="description" defaultValue={description}/>
                </Col>
            </Form.Group>

            {/* Current benefits */}
            {currentBenefitsRender}

            {/* New Benefit */}
            <Benefit benefitNum={benefitsCount} />

            <Button variant="primary" onClick={handleSave}>Save</Button>
            <Button variant="secondary" onClick={handleCancel}>Cancel</Button>
            <Button variant="danger" disabled={deleteDisabled} onClick={handleDelete}>Delete</Button>
            
        </Form>
    )
}

export default EditItem;
